<template>
  <div class="download">
    <h1 @click="openIoIn">打开小程序</h1>

    <h1 @click="openRouter">跳转页面</h1>
    <wx-open-launch-weapp
      id="launch-btn"
      username="gh_81ce5413794e"
      path="/pages/subscribe/subscribe.html"
    >
      <template>
        <button class="btn">打开小程序</button>
      </template>
    </wx-open-launch-weapp>
  </div>
</template>
<script setup>
import { onMounted, ref } from 'vue'
onMounted(() => {})

const openIoIn = () => {
  console.log(' window.wx',  window.wx)
  window.location.href = 'https://u.alipay.cn/_BqNPYnEEway3LgRtWgKw7'
  if (window.wx) {
    window.wx.miniProgram.navigateToMiniProgram({
      appId: 'wx8bd3d126e3a8a628',
      path: 'pages/subscribe/subscribe',
      extraData: {
        foo: 'bar'
      },
      success(res) {
        console.log('打开成功', res)
        // 打开成功
      }
    })
  } else {
    console.warn('window.wx 不存在')
  }
}

const openRouter = () => {
  if (window.wx) {
    window.wx.miniProgram.navigateTo({
      url: '/mine/coupon',
      success(res) {
        console.log('跳转成功', res)
        // 打开成功
      }
    })
  } else {
    console.warn('window.wx 不存在')
  }
}
</script>
<style scoped>
.download {
  padding: 50px;
  text-align: center;
}
.btn {
  padding: 12px;
  width: 200px;
  height: 50px;
}
</style>
